import styled from 'styled-components';


export const ToggleGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  margin-left: 10px;
  height: ${({theme}) => theme.size};
`;

export const ToggleItem = styled.div``;

export const Radio = styled.input`
  display: none;
  :checked + label {
    background: ${({theme}) => theme.COMMON};
    transform: scaleY(0.9);
  }
`;

export const Label = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({theme}) => theme.size};
  height: ${({theme}) => theme.size};
  border: none;
  cursor: pointer;
  user-select: none;
  background: ${({theme}) => theme.DARKLY};
  border-radius: ${(props) => (props.htmlFor === 'fid-1' ? '6px 0 0 6px' : '0 6px 6px 0')};
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  transition-duration: 0.5s;
  &:hover {
    cursor: pointer;
  }
`;
